module.exports = __webpack_public_path__ + "static/img/尹丽红.4d8ecb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teacher/尹丽红.jpg
// module id = EtX8
// module chunks = 140